import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const SaveCalculationModal = ({ onSave, onClose }) => {
  const [title, setTitle] = useState('');
  const [notes, setNotes] = useState('');

  const handleSave = () => {
    onSave(title, notes);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md p-6 rounded-xl bg-card border border-border shadow-xl">
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-bold text-foreground">Save Calculation</h3>
          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-muted transition-colors"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="space-y-4">
          <Input
            label="Title (Optional)"
            value={title}
            onChange={(e) => setTitle(e?.target?.value)}
            placeholder="e.g., BPC-157 Daily Dose"
          />

          <div className="space-y-2">
            <label className="text-sm font-medium text-foreground block">
              Notes (Optional)
            </label>
            <textarea
              value={notes}
              onChange={(e) => setNotes(e?.target?.value)}
              placeholder="Add any additional notes about this calculation..."
              rows={4}
              className="w-full px-3 py-2 rounded-md border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 resize-none"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              variant="outline"
              fullWidth
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              onClick={handleSave}
              className="bg-gradient-to-r from-primary to-secondary"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveCalculationModal;